import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiService } from 'src/app/service/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FileAlertComponent } from 'src/app/components/alerts/file-alert/file-alert.component'; 
import { AlertComponent } from 'src/app/components/modal/alert/alert.component';
import { SelectStockGEDCOMComponent } from 'src/app/components/modal/select-stock-gedcom/select-stock-gedcom.component';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { DeleteGedcomComponent } from 'src/app/components/modal/delete-gedcom/delete-gedcom.component';

@Component({
  selector: 'app-gedcom',
  templateUrl: './gedcom.component.html',
  styleUrls: ['./gedcom.component.scss']
})
export class GedcomComponent implements OnInit {
  gedcom: any = []
  officialGedcom: any = []
  gedcomLength
  displayedColumns: string[] = ['filename', 'uploaded', 'individuals', 'size', 'delete'];
  fileName: string = null;
  fileToUpload: File | null = null;
  fileInputName: string = null;
  userFilename = new UntypedFormControl('', Validators.required)
  showLoader: boolean = true;

  testArray: any = []

  constructor(private apiService: ApiService, private auth: AuthService, private MatDialog: MatDialog, private profileService: ProfileService) { }

  delete(file) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "alert-component";
    dialogConfig.data = {
      gedcomName: file.filename
    }
    const modalDialog = this.MatDialog.open(DeleteGedcomComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if(result == 'success'){ 
        this.apiService.deleteGedcom(file.id).then((d) => {
          this.getGedcomFiles();
        }, err => {
          console.log(err)
          this.getGedcomFiles();
        })
      } 
    })
    
  }

  getGedcom(id) {
    this.apiService.getGedcom(id).then((data) => {

    })
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getGedcomFiles() {
    this.gedcom = []
    this.apiService.getGedcoms().then((gedcoms: any) => {
      gedcoms.forEach(gedcom => {
        this.gedcom.push({ filename: gedcom.filename.split('-')[1], indis: gedcom.indis || 0, size: this.formatBytes(gedcom.size), uploaded: gedcom.uploaded, id: gedcom._id, publicGedcom: gedcom.publicGedcom  })
      });

      this.gedcom.sort((a: any, b: any) => {
        return <any>new Date(b.uploaded) - <any>new Date(a.uploaded);
      });
      this.showLoader = false;
    }, err => { console.log('error', err) })
  }


  openStockSelector(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "select-stockGEDCOM";
    dialogConfig.data = this.gedcom;
    const modalDialog = this.MatDialog.open(SelectStockGEDCOMComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      this.getGedcomFiles();
    })
  }

  async ngOnInit() {
    this.auth.getToken();
    this.gedcomLength = this.gedcom.length;
    this.getGedcomFiles();
      this.showLoader = false;
  }

}
